import React from 'react'
const UserContext = React.createContext({
    user: {},
    loggedIn: false,
    setUser: (newUser) => { this.user = newUser; },
    autoLogin: () => {},
})
export default UserContext;